import MaterialIcon from './MaterialIcon';

export { TYPES } from './MaterialIcon.constants';

export default MaterialIcon;
